import type { AiRoundtripStatus } from '@maland/contracts';
import type { ServiceState, TraceStatus } from '../types';
import { statusLabel } from '../lib/format';

type Status = ServiceState | TraceStatus | AiRoundtripStatus;

export function StatusPill({ status, compact = false }: { status: Status; compact?: boolean }) {
  return (
    <span className={`status-pill status-pill--${status}${compact ? ' status-pill--compact' : ''}`}>
      <span className="status-pill__dot" aria-hidden="true" />
      {statusLabel(status)}
    </span>
  );
}
